/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, output, TemplateRef, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { InputComponent } from '../../../../input/input.component';

@Component({
  selector: 'bn-web-ui-header-select-template',
  templateUrl: './header-select-template.component.html',
  imports: [FormsModule, FaIconComponent, InputComponent],
})
export class HeaderSelectTemplateComponent {
  // Default call this with type
  readonly headerTemplate = viewChild.required<TemplateRef<any>>('headerTemplate');
  // Could call templates directly by name
  readonly selectWithHeaderTextTemplate = viewChild.required<TemplateRef<any>>('selectWithHeaderTextTemplate');

  // Event that triggers close at parent model
  readonly closeChange = output<void>();

  // Event that triggers filter change at parent model
  readonly filterChange = output<string>();

  emitClose(): void {
    // TODO: The 'emit' function requires a mandatory void argument
    this.closeChange.emit();
  }

  emitFilterChange(search: string): void {
    this.filterChange.emit(search);
  }
}
